<template>
<div :class="$style.wrapper">
  <div :class="$style.inner">
    <l-video sm urlVideo="https://www.youtube.com/embed/_CHAUOZLiuw" />
    <l-video sm urlVideo="https://www.youtube.com/embed/4QOk96eTiBI" :withHeader="false">
      <h2>Рассказ о генерации музыки*</h2>
    </l-video>
  </div>
  <l-popupMessage :items="messages">
    <template #content="{item}">
      <div :class="$style.text" v-html="item.text"></div>
      <l-button :class="$style.btn" href="/competition" v-if="item.buttonTitle">{{ item.buttonTitle }}</l-button>
      <l-button :class="$style.btn" :href="link.link" v-if="item.buttonTitle2">{{ item.buttonTitle2 }}</l-button>
    </template>
  </l-popupMessage>
</div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'

import webhook from '@/webhook'

import { arr0 } from './arr'
import { pushPopup } from '@/utils/pushPopup'

export default {
  name: 'hub',
  setup() {
    const messages = ref([])
    onMounted(() => {
      pushPopup(arr0, messages.value)
    })

    const link = ref({ link: 'https://xn--h1adlhdnlo2c.xn--p1ai/lessons/music-and-it/certificate?session_id=34548eae-105e-4d65-b622-7bd15419559c' })
    const init = async () => {
      webhook.stopTimer()
      const res = await webhook.reqHook()
      link.value = res.data
    }

    init()

    return {
      link,
      messages,
    }
  },
}
</script>

<style scoped lang="scss" module>
  .wrapper {
    width: 100%;
    height: 100vh;
    background: $bgcHub;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .inner {
    width: 100%;
    max-height: 100%;
    overflow: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 5rem;
  }
  .text {
    margin-bottom: 1rem;
  }
  .btn {
    width: 100%;
  }
  .btn + .btn {
    background-color: #333333;
    color: $white;
    margin-top: 1rem;
  }
</style>
